// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"69d9a5e7","663":"df307a7d"}[chunkId] + ".chunk.js";
};